/* eslint-disable react/prop-types */
import { GridItem, FormControl, FormLabel, Input } from "@chakra-ui/react";
import PropTypes from "prop-types";

const FloatingLabelInput = ({
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  type,
  isRequired,
  pattern,
  isAutoCompleteOff,
}) => {
  console.log(isRequired,name);
  
  return (
    <GridItem pos="relative" w={"100%"}>
      <FormControl w={"100%"}>
        <Input
          placeholder=" "
          name={name}
          borderRadius="0"
          type={type || "text"}
          value={value || ""}
          onChange={onChange}
          required={isRequired || false}
          autoComplete={isAutoCompleteOff ? "off" : "on"}
          _focus={{
            borderColor: "blue.500",
            boxShadow: "0 0 0 1px blue.500",
          }}
          onBlur={onBlur}
          padding={pattern}
          w={"100%"}
          sx={{
            "&:focus + label, &:not(:placeholder-shown) + label": {
              top: "-10px",
              fontSize: "0.75rem",
              color: "blue.500",
            },
          }}
        />
        <FormLabel
          htmlFor="segmentName"
          pos="absolute"
          top="8px"
          left="8px"
          fontSize="1rem"
          transition="all 0.2s ease-in-out"
          pointerEvents="none"
          bg="white"
          borderRadius={"lg"}
          px="1"
          zIndex={8}
        >
          <span>{placeholder}</span>
          {isRequired && <span style={{ color: "red" }}>{"*"}</span>}
        </FormLabel>
      </FormControl>
    </GridItem>
  );
};
FloatingLabelInput.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  isAutoCompleteOff: PropTypes.bool,
};

export default FloatingLabelInput;
